import { render, staticRenderFns } from "./GroupsInactive.vue?vue&type=template&id=9216a484&scoped=true&"
import script from "./GroupsInactive.vue?vue&type=script&lang=js&"
export * from "./GroupsInactive.vue?vue&type=script&lang=js&"
import style0 from "./GroupsInactive.vue?vue&type=style&index=0&id=9216a484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9216a484",
  null
  
)

export default component.exports